import React from "react";
import { GeoAlt, Telephone, Envelope } from "react-bootstrap-icons";
import logo from "../../static/images/ClearPoint Trust Logo-Black_jpg.jpg";
import "./styles/Footer.css";

export default function Footer() {
  return (
    <footer className="cp-footer">
      <div className="cp-footer__inner">
        <div className="cp-footer__brand">
          <img className="cp-footer__logo" src={logo} alt="ClearPoint Trust" />
        </div>

        <div className="cp-footer__contact">
          <div className="cp-footer__item">
            <GeoAlt
              className="cp-footer__icon"
              aria-hidden="true"
              color="white"
            />
            <span>P.O. Box 59, Batesville, IN 47006</span>
          </div>
          <div className="cp-footer__item">
            <Telephone
              className="cp-footer__icon"
              aria-hidden="true"
              color="white"
            />
            <span>(800) 763-0234</span>
          </div>
          <div className="cp-footer__item">
            <Envelope
              className="cp-footer__icon"
              aria-hidden="true"
              color="white"
            />
            <a
              className="cp-footer__link"
              href="mailto:customer.service@clearpointfederal.com"
            >
              customer.service@clearpointfederal.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
